export default {
  "container": "_container_r8o1cm",
  "icon": "_icon_r8o1cm"
};
